import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSwitchToLogin: () => void;
  onOpenContactModal: (subject?: string) => void;
}

export const RegisterModal: React.FC<ModalProps> = ({ isOpen, onClose, onSwitchToLogin, onOpenContactModal }) => {
  const handleContactClick = () => {
    onClose();
    onOpenContactModal('Solicitud de Registro de Cuenta');
  };

  const handleLoginClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onSwitchToLogin();
  };

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title="Crear una Cuenta"
      containerClassName="max-w-lg"
      mainClassName="bg-gray-50"
    >
      <div className="text-center">
        <p className="text-gray-700 mb-6">
          Actualmente, la creación de cuentas se gestiona directamente con nuestro equipo para garantizar la máxima seguridad y un servicio personalizado.
        </p>
        <p className="text-gray-700 mb-8">
          Por favor, haz clic en el botón de abajo para enviarnos tus datos a través de nuestro formulario de contacto seguro, y te guiaremos en el proceso de alta.
        </p>
        <Button onClick={handleContactClick} variant="primary" size="large">
          Contactar para Registrarse
        </Button>
        <p className="mt-8 text-center text-sm text-gray-600">
          ¿Ya tienes una cuenta?{' '}
          <button onClick={handleLoginClick} className="font-medium text-blue-600 hover:underline">
            Inicia sesión
          </button>
        </p>
      </div>
    </ModalBase>
  );
};
